import CardGridSearch from './search';

export default CardGridSearch;